module.exports = __webpack_public_path__ + "img/arrowback.5fef1121.svg";